module.exports = "/images/logo-large.png?08ab02b1fef155bdcacb978963ffe3f3";